import { apiCall } from './gqlClient';
const GETFILES_QUERY = "\n  query getFiles($sectionId: String!) {\n    getFiles(sectionId: $sectionId)\n    {\n      id\n\t\t\tproductId\n\t\t\tsectionId\n\t\t\ttitle\n\t\t\tdescription\n\t\t\ttype\n\t\t\tfree\n\t\t\tintro\n\t\t\tname\n\t\t\tupdated\n\t\t\ttranscoded\n\t\t\torderIndex\n\t\t\tisPublic\n\t\t\ttempProductId\n\t\t\ttempFileId\n\t\t\tthumbnailUrl\n\t\t\tcopyId\n\t\t\tseen\n\t\t\tfileCreated\n\t\t\tdateCreated\n\t\t\tvideoUrl\n      ...fragments\n    }\n  }";
export const getFilesApiCall = async function (_ref) {
  let {
    sectionId
  } = _ref;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETFILES_QUERY,
    variables: {
      sectionId
    },
    fragments
  });
};
const GETALLMEDIAFILES_QUERY = "\n  query getAllMediaFiles {\n    getAllMediaFiles\n    {\n      id\n\t\t\tproductId\n\t\t\tsectionId\n\t\t\ttitle\n\t\t\tdescription\n\t\t\ttype\n\t\t\tfree\n\t\t\tintro\n\t\t\tname\n\t\t\tupdated\n\t\t\ttranscoded\n\t\t\torderIndex\n\t\t\tisPublic\n\t\t\ttempProductId\n\t\t\ttempFileId\n\t\t\tthumbnailUrl\n\t\t\tcopyId\n\t\t\tseen\n\t\t\tfileCreated\n\t\t\tdateCreated\n\t\t\tvideoUrl\n      ...fragments\n    }\n  }";
export const getAllMediaFilesApiCall = async function () {
  let fragments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return apiCall({
    query: GETALLMEDIAFILES_QUERY,
    variables: {},
    fragments
  });
};
const SAVEFILE_QUERY = "\n  query saveFile($request: FileInput!) {\n    saveFile(request: $request)\n    {\n      id\n\t\t\tcopyId\n\t\t\tpresignedUrl\n\t\t\tpresignedUrls\n\t\t\tsignedUrl\n\t\t\tsuccess\n\t\t\tname\n\t\t\tsectionIndex\n\t\t\ttype\n\t\t\tsignatureFileId\n      ...fragments\n    }\n  }";
export const saveFileApiCall = async function (_ref2) {
  let {
    request
  } = _ref2;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: SAVEFILE_QUERY,
    variables: {
      request
    },
    fragments
  });
};
const GETFILE_QUERY = "\n  query getFile($id: String!) {\n    getFile(id: $id)\n    {\n      id\n\t\t\tcopyId\n\t\t\tpresignedUrl\n\t\t\tpresignedUrls\n\t\t\tsignedUrl\n\t\t\tsuccess\n\t\t\tname\n\t\t\tsectionIndex\n\t\t\ttype\n\t\t\tsignatureFileId\n      ...fragments\n    }\n  }";
export const getFileApiCall = async function (_ref3) {
  let {
    id
  } = _ref3;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETFILE_QUERY,
    variables: {
      id
    },
    fragments
  });
};
const GETFILEFROMCUSTOMERFLOW_QUERY = "\n  query getFileFromCustomerFlow($fileId: String!, $customerFlowId: String!) {\n    getFileFromCustomerFlow(fileId: $fileId, customerFlowId: $customerFlowId)\n    {\n      id\n\t\t\tcopyId\n\t\t\tpresignedUrl\n\t\t\tpresignedUrls\n\t\t\tsignedUrl\n\t\t\tsuccess\n\t\t\tname\n\t\t\tsectionIndex\n\t\t\ttype\n\t\t\tsignatureFileId\n      ...fragments\n    }\n  }";
export const getFileFromCustomerFlowApiCall = async function (_ref4) {
  let {
    fileId,
    customerFlowId
  } = _ref4;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETFILEFROMCUSTOMERFLOW_QUERY,
    variables: {
      fileId,
      customerFlowId
    },
    fragments
  });
};
const GETFILEONBOARDING_QUERY = "\n  query getFileOnboarding($id: String!) {\n    getFileOnboarding(id: $id)\n    {\n      id\n\t\t\tcopyId\n\t\t\tpresignedUrl\n\t\t\tpresignedUrls\n\t\t\tsignedUrl\n\t\t\tsuccess\n\t\t\tname\n\t\t\tsectionIndex\n\t\t\ttype\n\t\t\tsignatureFileId\n      ...fragments\n    }\n  }";
export const getFileOnboardingApiCall = async function (_ref5) {
  let {
    id
  } = _ref5;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETFILEONBOARDING_QUERY,
    variables: {
      id
    },
    fragments
  });
};
const CHECKFILECONNECTIONS_QUERY = "\n  query checkFileConnections($id: String!, $name: String) {\n    checkFileConnections(id: $id, name: $name)\n  }";
export const checkFileConnectionsApiCall = async _ref6 => {
  let {
    id,
    name
  } = _ref6;
  return apiCall({
    query: CHECKFILECONNECTIONS_QUERY,
    variables: {
      id,
      name
    }
  });
};
const GETCUSTOMERFILE_QUERY = "\n  query getCustomerFile($id: String!, $providerId: Int!) {\n    getCustomerFile(id: $id, providerId: $providerId)\n    {\n      id\n\t\t\tcopyId\n\t\t\tpresignedUrl\n\t\t\tpresignedUrls\n\t\t\tsignedUrl\n\t\t\tsuccess\n\t\t\tname\n\t\t\tsectionIndex\n\t\t\ttype\n\t\t\tsignatureFileId\n      ...fragments\n    }\n  }";
export const getCustomerFileApiCall = async function (_ref7) {
  let {
    id,
    providerId
  } = _ref7;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETCUSTOMERFILE_QUERY,
    variables: {
      id,
      providerId
    },
    fragments
  });
};
const GETCUSTOMERPUBLICFILE_QUERY = "\n  query getCustomerPublicFile($id: String!, $providerId: Int!) {\n    getCustomerPublicFile(id: $id, providerId: $providerId)\n    {\n      id\n\t\t\tcopyId\n\t\t\tpresignedUrl\n\t\t\tpresignedUrls\n\t\t\tsignedUrl\n\t\t\tsuccess\n\t\t\tname\n\t\t\tsectionIndex\n\t\t\ttype\n\t\t\tsignatureFileId\n      ...fragments\n    }\n  }";
export const getCustomerPublicFileApiCall = async function (_ref8) {
  let {
    id,
    providerId
  } = _ref8;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETCUSTOMERPUBLICFILE_QUERY,
    variables: {
      id,
      providerId
    },
    fragments
  });
};
const GETSEENFILESREPORT_QUERY = "\n  query getSeenFilesReport($productId: String!, $users: [Int]!) {\n    getSeenFilesReport(productId: $productId, users: $users)\n    {\n      id\n\t\t\tname\n\t\t\temail\n\t\t\tsectionName\n\t\t\twatched\n\t\t\ttotal\n\t\t\tpercentage\n      ...fragments\n    }\n  }";
export const getSeenFilesReportApiCall = async function (_ref9) {
  let {
    productId,
    users
  } = _ref9;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETSEENFILESREPORT_QUERY,
    variables: {
      productId,
      users
    },
    fragments
  });
};
const ADDFILETOSECTION_QUERY = "\n  mutation addFileToSection($id: String!, $sectionId: String!, $sectionIndex: Int!) {\n    addFileToSection(id: $id, sectionId: $sectionId, sectionIndex: $sectionIndex)\n    {\n      id\n\t\t\tcopyId\n\t\t\tpresignedUrl\n\t\t\tpresignedUrls\n\t\t\tsignedUrl\n\t\t\tsuccess\n\t\t\tname\n\t\t\tsectionIndex\n\t\t\ttype\n\t\t\tsignatureFileId\n      ...fragments\n    }\n  }";
export const addFileToSectionApiCall = async function (_ref0) {
  let {
    id,
    sectionId,
    sectionIndex
  } = _ref0;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: ADDFILETOSECTION_QUERY,
    variables: {
      id,
      sectionId,
      sectionIndex
    },
    fragments
  });
};
const DELETEFILE_QUERY = "\n  mutation deleteFile($id: String!, $sectionIndex: Int) {\n    deleteFile(id: $id, sectionIndex: $sectionIndex)\n    {\n      id\n\t\t\tcopyId\n\t\t\tpresignedUrl\n\t\t\tpresignedUrls\n\t\t\tsignedUrl\n\t\t\tsuccess\n\t\t\tname\n\t\t\tsectionIndex\n\t\t\ttype\n\t\t\tsignatureFileId\n      ...fragments\n    }\n  }";
export const deleteFileApiCall = async function (_ref1) {
  let {
    id,
    sectionIndex
  } = _ref1;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: DELETEFILE_QUERY,
    variables: {
      id,
      sectionIndex
    },
    fragments
  });
};
const REORDERFILES_QUERY = "\n  mutation reorderFiles($sectionId: String!, $oldPosition: Int!, $newPosition: Int!) {\n    reorderFiles(sectionId: $sectionId, oldPosition: $oldPosition, newPosition: $newPosition)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const reorderFilesApiCall = async function (_ref10) {
  let {
    sectionId,
    oldPosition,
    newPosition
  } = _ref10;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: REORDERFILES_QUERY,
    variables: {
      sectionId,
      oldPosition,
      newPosition
    },
    fragments
  });
};
const DELETEALLFILESINSECTION_QUERY = "\n  mutation deleteAllFilesInSection($id: String!, $sectionIndex: Int!) {\n    deleteAllFilesInSection(id: $id, sectionIndex: $sectionIndex)\n    {\n      id\n\t\t\tcopyId\n\t\t\tpresignedUrl\n\t\t\tpresignedUrls\n\t\t\tsignedUrl\n\t\t\tsuccess\n\t\t\tname\n\t\t\tsectionIndex\n\t\t\ttype\n\t\t\tsignatureFileId\n      ...fragments\n    }\n  }";
export const deleteAllFilesInSectionApiCall = async function (_ref11) {
  let {
    id,
    sectionIndex
  } = _ref11;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: DELETEALLFILESINSECTION_QUERY,
    variables: {
      id,
      sectionIndex
    },
    fragments
  });
};
const MARKFILESEENUNSEEN_QUERY = "\n  mutation markFileSeenUnseen($fileId: String!, $seen: Boolean!) {\n    markFileSeenUnseen(fileId: $fileId, seen: $seen)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const markFileSeenUnseenApiCall = async function (_ref12) {
  let {
    fileId,
    seen
  } = _ref12;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: MARKFILESEENUNSEEN_QUERY,
    variables: {
      fileId,
      seen
    },
    fragments
  });
};